<template>
  <div class="container-fluid">
    <div class="row justify-content-center">
      <div class="col-12">
        <indexHeader
          :title="$t('accountsDeposits.accountsDeposits')"
          :description="
            $t('accountsDeposits.fromHereYouCanControlAccountDeposits')
          "
        />
        <indexTable
          :searchText="$t('accountsDeposits.SearchForAnOperation')"
          :emptyTableText="$t('accountsDeposits.ThereAreCurrentlyNoDeposits')"
          :buttonRole="$user.role.accounts_deposits_add"
          :emptyTableSubText="
            $t('allerts.TryAddingSomeItemsToTheTableAndTryAgain')
          "
          :statusSearch="true"
          :statusValues="[
            { title: $t('orders.situation'), value: ''},
            { title: $t('orders.all'), value: ''},
            { title: $t('invoices.draft'), value: 0 },
            { title: $t('invoices.approved'), value: 1 },
          ]"
          :cloumns="[
            {
              column: 'code',
              title: $t('accountsDeposits.Process'),
              type: 'mainLink',
              sort: true,
            },
            {
              column: 'account_id',
              title: $t('accountsDeposits.accountName'),
              type: 'link',
              to: 'account',
              sort: true,
              link: true,
            },
            {
              column: 'safe_id',
              title: $t('accountsDeposits.Treasury'),
              type: 'link',
              to: 'safe',
              sort: true,
              link: true,
            },
            {
              column: 'date',
              title: $t('accountsDeposits.date'),
              type: 'text',
              sort: true,
            },
            {
              column: 'description',
              title: $t('accountsDeposits.AndThatIsAbout'),
              type: 'text',
              sort: true,
            },
            {
              column: 'cost',
              title: $t('accountsDeposits.cost'),
              type: 'text',
              sort: true,
            },
            {column: 'status', title: $t('bills.situation') ,type: 'status' , sort: true ,  values: [
                  {title: $t('invoices.draft'), value: 0, color: 'dark'},
                  {title: $t('invoices.approved'), value: 1, color: 'success'},
                ]
            },
            {
              column: 'options',
              title: $t('accountsDeposits.actions'),
              type: 'options',
              options: [
                { name: 'show' },
                {name: 'printAccountsDeposit',   role: true},
                {
                  name: 'edit',
                  role:
                    $user.admin || $user.role.accounts_deposits_edit,
                },
                {name: 'file'},
                /*
                { name: 'printSalesPayment', role: true },
                { name: 'download', role: true },

                */
                {
                  name: 'delete',
                  role:
                    $user.admin ||
                    $user.role.accounts_deposits_delete,
                },
              ],
            },
          ]"
          :deleteText="{
            attention: $t('allerts.Attention'),
            areYouReallySureToDeleteTheItem: $t(
              'allerts.areYouReallySureToDeleteTheItem'
            ),
            close: $t('allerts.close'),
            confirm: $t('allerts.confirm'),
            loading: $t('allerts.loading'),
          }"
        />
      </div>
    </div>
  </div>
</template>
<script>

import indexHeader from "../elements/index/indexHeader.vue";
import indexTable from "../elements/index/indexTable.vue";

export default {
  data() {
    return {
      path: "/accountsDeposits"
    };
  },
  components: {
    indexHeader,
    indexTable,
  },
};
</script>
